import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postProject } from './projects';
import { TypesenseCollection } from '@/api/typesense/types';

export const useCreateProject = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postProject,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [TypesenseCollection.PROJECTS_VIEW.name],
      });
    },
  });
};
